import React, { useRef } from 'react';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from '../../theme/styles';
import { getConfigVariable } from '../../common/fn/Config';
import useStickyHeaderReserve from '../../hooks/useStickyHeaderReserve';
import HoldTimer from './HoldTimer';

const HeaderV2 = (props) => {
  const { shouldShowBackButton, backButtonFn, classes } = props;
  const CONTENT_URI = getConfigVariable('CONTENT_URI');
  const headerRef = useRef(null);
  useStickyHeaderReserve(headerRef);

  return (
    <header
      ref={headerRef}
      role="banner"
      className={classes.headerContainerV2}
    >
      <AppBar position="static">
        <Toolbar className={classes.appbarToolbar}>
          <div className={classes.appbarSideStart}>
            {shouldShowBackButton && (
              <IconButton
                edge="start"
                className={classes.appbarBackButton}
                color="inherit"
                aria-label="back"
                onClick={() => {
                  backButtonFn();
                }}
              >
                <ArrowBack />
              </IconButton>
            )}
          </div>

          <div className={classes.appbarTitleContainer}>
            <Typography
              variant="h4"
              component="div"
              className={classes.appbarTitle}
              align="center"
            >
              <a href={CONTENT_URI}>Derick Dermatology</a>
            </Typography>
          </div>

          <div className={classes.appbarSideEnd}>
            <HoldTimer />
          </div>
        </Toolbar>
      </AppBar>
    </header>
  );
};

HeaderV2.propTypes = {
  classes: PropTypes.object,
  shouldShowBackButton: PropTypes.bool,
  backButtonFn: PropTypes.func,
};

export default withStyles(styles)(HeaderV2);
